/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/shared/ui/components/shadcn/sheet';

export type DrawerProps = {
  opened: boolean;
  onClose: () => void;
  position?: 'top' | 'bottom' | 'left' | 'right';
  title?: string;
  size?: string | number;
  children: React.ReactNode;
  className?: string;
};

/**
 * Drawer adapter that delegates to the shadcn Sheet primitive.
 *
 * @param {DrawerProps} props - Drawer properties.
 * @returns {JSX.Element} Rendered sheet/drawer.
 */
export const Drawer: React.FC<DrawerProps> = ({
  opened,
  onClose,
  position = 'bottom',
  title,
  children,
  className,
}) => {
  return (
    <Sheet open={opened} onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent side={position} className={className}>
        {title && (
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
          </SheetHeader>
        )}
        <div className="overflow-y-auto flex-1">{children}</div>
      </SheetContent>
    </Sheet>
  );
};

export default Drawer;
